import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function AboutPage() {
  const breadcrumbJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'http://baoliaoshe.cn/' },
      { '@type': 'ListItem', position: 2, name: '关于我们', item: 'http://baoliaoshe.cn/about' },
    ],
  };

  const aboutJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于51吃瓜网',
    description: '51吃瓜网成立于2020年，是国内领先的娱乐八卦内容聚合平台。致力于为吃瓜群众提供最新、最全、最真实的吃瓜爆料内容。',
    url: 'http://baoliaoshe.cn/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '51吃瓜网',
      url: 'http://baoliaoshe.cn/',
    },
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '51吃瓜网的内容是否真实可靠？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '51吃瓜网严格审核每一条爆料信息，内容真实率高达99.7%，确保用户获取到的都是经过验证的真实爆料内容。',
        },
      },
      {
        '@type': 'Question',
        name: '如何下载51吃瓜APP？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以在官网首页底部找到Android和iOS下载入口，点击对应按钮即可下载安装。APP已通过安全检测，请放心使用。',
        },
      },
      {
        '@type': 'Question',
        name: '如何向51吃瓜网投稿爆料？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '欢迎通过投稿邮箱 hello@baoliaoshe.cn 发送您的爆料内容。我们会对每一条投稿进行审核，优质内容将获得优先展示。',
        },
      },
      {
        '@type': 'Question',
        name: '51吃瓜网是否收费？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '51吃瓜网所有内容完全免费，用户无需支付任何费用即可浏览全部吃瓜爆料内容。',
        },
      },
    ],
  };

  return (
    <>
      <Navbar />
      <main>
        <section className="pt-16">
          <div className="relative w-full h-[300px] md:h-[380px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Dark%20atmospheric%20modern%20office%20environment%20with%20warm%20orange%20ambient%20lighting%2C%20abstract%20geometric%20elements%2C%20editorial%20style%2C%20clean%20minimal%20composition%2C%20professional%20aesthetic&width=1800&height=700&seq=about-hero&orientation=landscape"
              alt="关于51吃瓜网"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 to-black/80"></div>
            <div className="relative z-10 w-full h-full flex items-center px-4 md:px-6">
              <div>
                <nav className="flex items-center gap-2 text-sm text-white/60 mb-4">
                  <Link to="/" className="hover:text-white transition-colors">首页</Link>
                  <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center"></i>
                  <span className="text-white">关于我们</span>
                </nav>
                <h1 className="text-3xl md:text-5xl font-heading font-bold text-white tracking-tight">
                  关于51吃瓜网
                </h1>
                <p className="text-sm md:text-base text-white/70 mt-2 max-w-lg">
                  吃瓜群众的一手资源核心发布页
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-14 md:py-20">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-4xl mx-auto">
              <div className="text-center mb-12">
                <span className="text-xs font-medium text-primary-600 tracking-widest uppercase">About Us</span>
                <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mt-3 tracking-tight">
                  品牌<span className="italic text-primary-500" style={{ fontFamily: 'var(--font-heading)' }}>介绍</span>
                </h2>
                <p className="text-sm text-foreground-500 mt-3 max-w-xl mx-auto leading-relaxed">
                  51吃瓜网成立于2020年，是国内领先的娱乐八卦内容聚合平台。我们致力于为吃瓜群众提供最新、最全、最真实的吃瓜爆料内容。
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
                <div className="bg-accent-500/10 rounded-2xl p-8 md:p-10 relative overflow-hidden">
                  <div className="absolute top-6 right-6 w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
                    <i className="ri-arrow-right-up-line text-white text-lg"></i>
                  </div>
                  <span className="text-5xl md:text-6xl font-heading font-black text-accent-500">99.7%</span>
                  <p className="text-sm text-foreground-700 mt-3 leading-relaxed">
                    内容真实率行业领先，严格审核每一条爆料信息，确保用户获取到的都是真实可靠的吃瓜内容。
                  </p>
                  <p className="text-xs italic text-foreground-500 mt-4">真实是我们的底线</p>
                </div>
                <div className="bg-secondary-100 rounded-2xl p-8 md:p-10 relative overflow-hidden">
                  <div className="absolute top-6 right-6 w-10 h-10 rounded-full bg-white/40 flex items-center justify-center">
                    <i className="ri-arrow-right-up-line text-foreground-700 text-lg"></i>
                  </div>
                  <span className="text-5xl md:text-6xl font-heading font-black text-secondary-600">580万+</span>
                  <p className="text-sm text-foreground-700 mt-3 leading-relaxed">
                    日活跃用户超过580万，累计注册用户突破3200万，是中文互联网最具影响力的吃瓜内容平台。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-50 py-14 md:py-20">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-4xl mx-auto text-center">
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 tracking-tight">
                用户<span className="italic text-primary-500" style={{ fontFamily: 'var(--font-heading)' }}>口碑</span>
              </h2>
              <p className="text-sm text-foreground-500 mt-3 max-w-xl mx-auto">
                听听吃瓜群众怎么说
              </p>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mt-10">
                {[
                  { name: '吃瓜小能手', text: '自从用了51吃瓜，再也不用到处找瓜了！每天打开APP就能看到最新爆料，更新速度太快了，简直是吃瓜党的福音！', rating: 5 },
                  { name: '八卦雷达', text: '内容质量很高，不像其他平台那么多假瓜。51吃瓜的爆料都是有实锤的，看着特别过瘾，已经推荐给身边所有朋友了。', rating: 5 },
                  { name: '追瓜达人', text: '分类很清晰，想吃什么类型的瓜都能快速找到。界面也很清爽，没有乱七八糟的广告，体验感非常好。', rating: 5 },
                ].map((review) => (
                  <div key={review.name} className="bg-background-50 border border-background-200/70 rounded-xl p-6 text-left">
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: review.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-amber-400 text-sm w-4 h-4 flex items-center justify-center"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed">{review.text}</p>
                    <p className="text-xs font-semibold text-foreground-900 mt-4">— {review.name}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-14 md:py-20">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-4xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 tracking-tight">
                  联系<span className="italic text-primary-500" style={{ fontFamily: 'var(--font-heading)' }}>我们</span>
                </h2>
                <p className="text-sm text-foreground-500 mt-3">
                  如有任何问题或合作意向，欢迎通过以下方式联系我们
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
                <div className="bg-background-50 rounded-xl p-6 text-center border border-background-200/70">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto mb-3">
                    <i className="ri-mail-line text-xl"></i>
                  </span>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">商务合作</h3>
                  <a href="mailto:hello@baoliaoshe.cn" className="text-xs text-primary-500 hover:text-primary-600 transition-colors">
                    hello@baoliaoshe.cn
                  </a>
                </div>
                <div className="bg-background-50 rounded-xl p-6 text-center border border-background-200/70">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-3">
                    <i className="ri-send-plane-line text-xl"></i>
                  </span>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">内容投稿</h3>
                  <a href="mailto:hello@baoliaoshe.cn" className="text-xs text-primary-500 hover:text-primary-600 transition-colors">
                    hello@baoliaoshe.cn
                  </a>
                </div>
                <div className="bg-background-50 rounded-xl p-6 text-center border border-background-200/70">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mx-auto mb-3">
                    <i className="ri-error-warning-line text-xl"></i>
                  </span>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">投诉建议</h3>
                  <a href="mailto:hello@baoliaoshe.cn" className="text-xs text-primary-500 hover:text-primary-600 transition-colors">
                    hello@baoliaoshe.cn
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-50 py-14 md:py-20">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center tracking-tight mb-10">
                常见<span className="italic text-primary-500" style={{ fontFamily: 'var(--font-heading)' }}>问题</span>
              </h2>

              <div className="space-y-4">
                {[
                  { q: '51吃瓜网的内容是否真实可靠？', a: '51吃瓜网严格审核每一条爆料信息，内容真实率高达99.7%，确保用户获取到的都是经过验证的真实爆料内容。' },
                  { q: '如何下载51吃瓜APP？', a: '您可以在官网首页底部找到Android和iOS下载入口，点击对应按钮即可下载安装。APP已通过安全检测，请放心使用。' },
                  { q: '如何向51吃瓜网投稿爆料？', a: '欢迎通过投稿邮箱 hello@baoliaoshe.cn 发送您的爆料内容。我们会对每一条投稿进行审核，优质内容将获得优先展示。' },
                  { q: '51吃瓜网是否收费？', a: '51吃瓜网所有内容完全免费，用户无需支付任何费用即可浏览全部吃瓜爆料内容。' },
                  { q: '如何联系商务合作？', a: '商务合作请发送邮件至 hello@baoliaoshe.cn，我们的商务团队会在1-2个工作日内回复。' },
                ].map((faq) => (
                  <details key={faq.q} className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
                    <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                      <span className="text-sm font-medium text-foreground-900 pr-4">{faq.q}</span>
                      <span className="w-5 h-5 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-open:rotate-45 transition-transform duration-200">
                        <i className="ri-add-line text-sm"></i>
                      </span>
                    </summary>
                    <div className="px-5 pb-4">
                      <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
    </>
  );
}